export const isNonEmpty = (value?: string) => {
  return value !== undefined && value.trim() !== '';
}